import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {ProofBeforeBeginPage} from './proof-before-begin';

import {PipesModule} from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    ProofBeforeBeginPage,
  ],
  imports: [
    IonicPageModule.forChild(ProofBeforeBeginPage),
    PipesModule,
  ],
  exports: [
    ProofBeforeBeginPage
  ]
})
export class ProofBeforeBeginPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/proof-before-begin/proof-before-begin.module.ts